import styled from "styled-components";

import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";

import { useModal } from "../../contexts/ModalContext";

const Title = styled.h3`
    margin: 0 0 12px 0;
    font-size: 14px;
    font-weight: 700;
    color: #1f2937;
`;

const Subtitle = styled.div`
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 16px;
`;

const Actions = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const ActionBtn = styled.button`
    width: 100%;
    padding: 14px 16px;
    border-radius: 8px;
    border: 1px solid #d1d5db;
    background: #f8fafc;
    font-size: 13px;
    font-weight: 700;
    color: #1f2937;
    text-align: left;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
        background: #e2e8f0;
        border-color: #94a3b8;
    }
`;

/**
 * Menu de ações para a obra (centro de custo) selecionada.
 * Recebe callbacks que abrem os respectivos modais de cadastro.
 * Overlay não fecha ao clicar — só pelo X.
 */
const ModalAcoesObra = ({ obra, onCadastrarDistancias, onCadastrarValores }) => {

    const { closeModal } = useModal();

    if (!obra) return null;

    return (
        <Overlay state>
            <Modal size="sm" header close={closeModal}>
                <Title>{obra.obra}</Title>
                <Subtitle>
                    Prazo do ciclo: <strong>{obra.dias_prazo}</strong> dias
                </Subtitle>

                <Actions>
                    <ActionBtn type="button" onClick={onCadastrarDistancias}>
                        CADASTRAR DISTÂNCIAS
                    </ActionBtn>
                    <ActionBtn type="button" onClick={onCadastrarValores}>
                        CADASTRAR VALORES (FAIXAS)
                    </ActionBtn>
                </Actions>
            </Modal>
        </Overlay>
    );
};

export default ModalAcoesObra;
